let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6zB8z")).then(() => parcelRequire('9sJzD'));